import { getRowId } from './getRowId';

// Ids of selected rows that are not in the loaded data (paired by dataKey).
export const getMissingSelectedRowIds = (
  selectedRows: any[],
  data: any[],
  dataKey: string
): string[] => {
  const loadedIds = new Set(
    data.map((row) => getRowId(row, dataKey)).filter((id) => id !== null)
  );

  return selectedRows
    .map((row) => getRowId(row, dataKey))
    .filter((id): id is string => id !== null && !loadedIds.has(id));
};
